import {
    Button,
    Form,
    TextInput,
    useGetOne,
    useNotify,
    useTranslate,
    useUpdate,
} from 'react-admin';
import DialogTemplate from '@/components/common/dialog-template/dialog-template';
import Box from '@mui/material/Box';
import ButtonsBlock from '@/components/common/buttons-block/buttons-block';
import LoadingButton from '@mui/lab/LoadingButton';
import Joi from 'joi';
import { joiResolver } from '@hookform/resolvers/joi';
import FormInputsSeparator from '@/components/common/form-inputs-separator/form-inputs-separator';
import { GROUP_USERS } from '@/utils/CONST';
import { useNavigate, useParams } from 'react-router';
import { composeUri } from '@/utils/compose';

const EditAgency = () => {
    const [update, { isLoading: isLoadingUpdate }] = useUpdate();
    const { agencyId } = useParams();
    const { data, isLoading } = useGetOne(GROUP_USERS, { id: composeUri(GROUP_USERS, agencyId) });
    const translate = useTranslate();
    const notify = useNotify();

    const navigate = useNavigate();

    const handleEditAgency = (values: any) => {
        update(
            GROUP_USERS,
            {
                id: composeUri(GROUP_USERS, agencyId),
                data: {
                    name: values.agency,
                },
            },
            {
                onSuccess: () => {
                    notify('ra.notification.updated', { type: 'success' });
                    navigate(-1);
                },
            },
        );
    };

    const agencySchema = Joi.object({
        agency: Joi.string().required(),
    });

    return (
        <DialogTemplate title={translate('agency.form.title_edit')} open={true}>
            <Form
                onSubmit={handleEditAgency}
                resolver={joiResolver(agencySchema)}
                defaultValues={{ agency: data?.name }}
                // resolver={async (data, context, options) => await debugSchema(data, context, options, agencySchema)}
            >
                <Box sx={{ display: 'grid', gap: 2 }}>
                    <FormInputsSeparator>
                        <TextInput
                            helperText={false}
                            name={'agency'}
                            source={'agency'}
                            label={'agency.form.agency_name'}
                        />
                    </FormInputsSeparator>
                    <ButtonsBlock>
                        <Button
                            onClick={() => navigate(-1)}
                            disabled={isLoadingUpdate || isLoading}
                            label={'ra.action.cancel'}
                        ></Button>
                        <LoadingButton loading={isLoadingUpdate || isLoading} type={'submit'} variant={'contained'}>
                            {translate('ra.action.edit')}
                        </LoadingButton>
                    </ButtonsBlock>
                </Box>
            </Form>
        </DialogTemplate>
    );
};

export default EditAgency;
